export default ( {trigger}, resolve, self) => {
  return self.menuIsOpen ?  self.expandMenuItem(trigger, resolve) : self.switchMainCurtain(true, resolve, trigger);

}
